// extracted by mini-css-extract-plugin
export default {"card":"bsS10","image":"sVwKb"};